import {ProjectTCO} from '../../../../models/tco-info';
import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MyProjectsTableRowActionEnum} from '../../../../enums/my-project-table-row-action.enum';
import {ProjectsListItemModel} from '../../../../models/projects-list-item.model';
import {IProjectService} from 'src/app/modules/projects/services/project.service.interface';
import {ProjectStatusEnum} from '../../../../enums/project-status.enum';

@Component({
    selector: 'app-actions-menu',
    templateUrl: './actions-menu.component.html',
    styleUrls: ['./actions-menu.component.scss']
})
export class ActionsMenuComponent {

    @Output() public menuItemClicked = new EventEmitter<MyProjectsTableRowActionEnum>();
    @Input() public menuItems: { label: string, faName: string, actionId: MyProjectsTableRowActionEnum }[];

    @Input() public projectListItem: ProjectsListItemModel;


    // tslint:disable-next-line:member-ordering
    @ViewChild('actionMenuModal', {read: ElementRef}) actionMenuModal: ElementRef; // p.checked1

    public isMenuVisible = false;
    public isTCODraft = false;
    private projectTCO: ProjectTCO = null;
    public actionEnum = MyProjectsTableRowActionEnum;

    constructor(private projectService: IProjectService) {
    }

    public menuRowClicked(actionId: MyProjectsTableRowActionEnum) {
        if (!this.isActionMenuItemDisabled(actionId)) {
            this.menuItemClicked.emit(actionId);


        }
    }


    private async initProjectTCO(): Promise<void> {

        if (this.projectListItem !== null && this.projectListItem !== undefined) {

            try {

                this.projectTCO = await this.projectService.getProjectTCO(this.projectListItem.id);
            } finally {
                // tslint:disable-next-line:max-line-length
                if (this.projectTCO !== null && this.projectTCO.tcoInfo.tcoStatus !== null && this.projectTCO.tcoInfo.tcoStatus === 'DRAFT') {
                    this.isTCODraft = true;

                }
            }


        }


    }


    public isActionMenuItemDisabled(actionId: MyProjectsTableRowActionEnum) {

        const isProjectStatusInProcessActive =
            this.projectListItem && (ProjectStatusEnum[this.projectListItem.status] !== ProjectStatusEnum.DRAFT && ProjectStatusEnum[this.projectListItem.status] !== ProjectStatusEnum.REQUEST);
        return isProjectStatusInProcessActive &&
            (actionId === MyProjectsTableRowActionEnum.EDIT || actionId === MyProjectsTableRowActionEnum.DELETE);
    }

    public isInternalUser() {
        return false;
    }


    public open() {
        this.isMenuVisible = true;
        this.checkActionMenuPosition();
        this.initProjectTCO();


    }

    public close() {
        this.isMenuVisible = false;
    }


    // move action menu if is not fully visible on browser window screen ( hidden behind bottom window edge)
    // also set visibility to visible
    private checkActionMenuPosition() {
        const minBottomMargin = 2;
        setTimeout(() => {
            const windowHeight = window.innerHeight;
            const rect = this.actionMenuModal.nativeElement.getBoundingClientRect();
            const deltaY = rect.bottom + minBottomMargin - windowHeight;
            if (deltaY > 0) {  // bottom menu edge is not visible
                this.actionMenuModal.nativeElement.style.top = (-rect.height) + 'px';
            }

            this.actionMenuModal.nativeElement.style.visibility = 'visible';

        }, 0);
    }
}
